import { useFormContext } from "react-hook-form";
import { COUNTY_COUNTRY_CODES } from "@/common/constants";
import { useAddressLocationOptions } from "@/common/hooks/use-address-location-options";
import type { CheckoutFormState } from "@/pages/Checkout/checkout-form.types";
import { useSession } from "@/common/providers/session-provider";

interface UseChangeShippingDetailsCardProps {
  country: string;
  state: string;
  onCountryChange: (country: string) => void;
}

export const useChangeShippingDetailsCard = ({
  country,
  state,
  onCountryChange,
}: UseChangeShippingDetailsCardProps) => {
  const { username } = useSession();
  const { resetField, setValue } = useFormContext<CheckoutFormState>();
  const { countries, phoneCodes, matchedCountry, states, cities, isStatesLoading, isCitiesLoading } =
    useAddressLocationOptions(country, state);

  const handleCountryChange = (selectedCountryName: string) => {
    const selectedCountry = countries.find((candidate) => candidate.name === selectedCountryName);
    onCountryChange(selectedCountryName);
    setValue("countryCode", selectedCountry?.phonecode ?? "", { shouldDirty: true });
    setValue("countryISO3", selectedCountry?.iso3 ?? "", { shouldDirty: true });
    if (!COUNTY_COUNTRY_CODES.includes(selectedCountry?.iso2 ?? "")) {
      resetField("county", { defaultValue: "" });
    }
  };

  return {
    cities,
    countries,
    handleCountryChange,
    isCountyEnabled: COUNTY_COUNTRY_CODES.includes(matchedCountry?.iso2 ?? ""),
    isStatesLoading,
    isCitiesLoading,
    phoneCodes,
    states,
    username,
  };
};
